import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isVideoDevice       : false,   // 视频设备是否使用中, 暂不使用
        recordConfig        : {},      // 监管配置
        questData           : {},      // 参数配置
        recordStartTime     : 0,       // 视频录制定时 毫秒
        currentTime         : 0,       // 当前播放时间点
        catalogId           : '',      // 当前章节 ID
        videoStartFaceOnce  : false,   // 第一次播放视频是否人脸识别
        isFaceloading       : false,   // 人脸识别中
        isCodeloading       : false,   // 验证码验证中
        isVideoRecordloading: false,   // 视频录制中

        playVideoChapterId: '0',         // 正在播放视频的章节 ID
        mapChapters       : new Map(),   // 当前播放课件的章节集合
        playVideoChapter  : {},          // 当前播放课件章节
        clientConfig      : {},          // 客户端配置
        chapterIds        : ''           // 试听章节

    },
    mutations: {
        // 改变视频设备使用状态
        setVideoDevice(state, videoDevice) {
            state.isVideoDevice = videoDevice;
        },
        // 设置监管配置
        setRecordConfig(state, recordConfig) {
            state.recordConfig = recordConfig;
        },
        // 设置视频录制定时
        setRecordStartTime(state, recordStartTime) {
            state.recordStartTime = recordStartTime;
        },
        // 设置参数
        setQuestData(state, questData) {
            state.questData = questData;
        },
        // 设置当前时间点
        setCurrentTime(state, currentTime) {
            state.currentTime = currentTime;
        },
        // 设置当前章节 ID
        setCatalogId(state, catalogId) {
            state.catalogId = catalogId;
        },
        // 设置第一次播放视频是否人脸识别
        setVideoStartFaceOnce(state, videoStartFaceOnce) {
            state.videoStartFaceOnce = videoStartFaceOnce;
        },
        // 人脸识别中弹窗
        setIsFaceloading(state, isFaceloading) {
            state.isFaceloading = isFaceloading;
        },
        // 验证码验证中弹窗
        setIsCodeloading(state, isCodeloading) {
            state.isCodeloading = isCodeloading;
        },
        // 视频录制中弹窗
        setIsVideoRecordloading(state, isVideoRecordloading) {
            state.isVideoRecordloading = isVideoRecordloading;
        },
        // 设置正在播放视频的章节 ID
        setPlayVideoChapterId(state, chapterId) {
            state.playVideoChapterId = chapterId;
        },
        // 设置当前播放课件的章节集合
        setMapChapters(state, mapChapters) {
            state.mapChapters = mapChapters;
        },
        // 设置当前播放课件章节
        setPlayVideoChapter(state, playVideoChapter) {
            state.playVideoChapter = playVideoChapter;
        },
        setFreeCatalogIds(state, chapterIds) {
            state.chapterIds = chapterIds;
        }

    },
    actions: {

    },
});
